module.exports = (require("./helpers/browser/js-loader")(parcelRequire.resolve("d5GAD"))).then(() => parcelRequire('57Q60'));